<script lang="ts" setup>
import { UNIFIED_ROUTE_LEARN } from '~/constants/routes/unified';

const logos = [
  { imagePath: '/images/kui/anyway/partners/westpac.webp', class: 'w-[6.25rem] h-[3rem]', name: 'Westpac' },
  { imagePath: '/images/kui/anyway/partners/microsoft-1.webp', class: 'w-[11.813rem] h-[2.563rem]', name: 'Microsoft' },
  { imagePath: '/images/kui/anyway/partners/kpmg.webp', class: 'w-[6.375rem] h-[2.563rem]', name: 'KPMG' },
  { imagePath: '/images/kui/anyway/partners/ca-anz.webp', class: 'w-[6.565rem] h-[3rem]', name: 'CA ANZ' },
  { imagePath: '/images/kui/anyway/partners/coca-cola.webp', class: 'w-[11.875rem] h-[2.063rem]', name: 'Coca Cola' },
];
</script>

<template>
  <KUIUnifiedRealCareers :logos="logos" :href="UNIFIED_ROUTE_LEARN" />
</template>
